export const MENTION_UPCASED_TYPE = 'Mention';
export const MENTION_PORTAL_ID = 'mention_portal_id';
